import React, { useContext } from 'react'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import style from "../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"; 
import contactStyle from "../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import { Autocomplete, Divider, Grid, TextField, Typography } from '@mui/material';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../context/workflowContext';
import Required from '../../../../utility/required';
import { actionTypeForException, defaultChatbotStep, defaultTargetChatbotStep, isStartNode } from '../../flowBuilderConstants';
import { chatbotStepData, handleErrorActionType, staticWorkflowChatbotDetails } from '../../../../../models/axiosModel';
import GlobalButton from '../../../../utility/globalButton/button';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext';
import { isCurrentViewVersionPublished } from '../../utilityFunctions';
import { isWhatsAppChannel } from '../../../../../pages/ruleBasedInbox/channelConstants';

interface ExceptionPopupProps {
    setFlagExceptionPopup: React.Dispatch<React.SetStateAction<boolean>>,
    handlePostDeploymentTrigger: (flag_delete: boolean) => Promise<void>,
    onClickOfCancel: () => void,
    flagStepLevel?: boolean, 
    stepId?: string,
}

const ExceptionPopup: React.FC<ExceptionPopupProps> = (props) => {
    
    const { setFlagExceptionPopup, handlePostDeploymentTrigger, onClickOfCancel, flagStepLevel, stepId } = props;

    const { currentActiveStaticWorkflow, setCurrentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload; 
    const { updateException, nodes, setNodes, edges, getChatbotPostDeploymentTriggerTypeApi, chatbotPostDeploymentTriggerType } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    
    const channelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name;
    const isWhatsapp = isWhatsAppChannel(channelName);
    
    const getValue = (type: 'actionType' | 'chatbotStep' | 'textMessage') => {
        if(!currentActiveStaticWorkflow) return undefined;

        const chatbotException = currentActiveStaticWorkflow?.chatbot_exception;
        const stepException = nodes?.find((node: any) => node?.id == stepId)?.chatbot_step_exception;

        switch(type){
            case 'actionType':
                let actionType = "";
                if(flagStepLevel){
                    actionType = stepException?.action_type || "";
                } else {
                    actionType = chatbotException?.action_type || "";
                } 
                console.log("actionType", actionType);
                return actionTypeForException(currentActiveStaticWorkflow)?.find((action) => action?.key?.toLowerCase() == actionType?.toLowerCase()) ?? undefined;
            case 'chatbotStep': 
                let step_id = "";
                if(flagStepLevel){
                    step_id = stepException?.target_chatbot_step?.target_chatbot_step_id || "";
                } else {
                    step_id = chatbotException?.chatbot_step?.chatbot_step_id || "";
                }
                return flagStepLevel ? nodes?.find((node: any) => node?.id == step_id) ?? undefined : currentActiveStaticWorkflow?.chatbot_version_info?.find((version) => version.chatbot_version_status_name?.toLowerCase() == currentActiveStaticWorkflow?.currentViewVersion?.toLowerCase())?.chatbot_step_data?.find((step) => step.chatbot_step_id == step_id) ?? undefined;
            case 'textMessage': 
                if(flagStepLevel){
                    return stepException?.exception_message || "";
                } else {
                    return chatbotException?.pre_transition_text_message || "";
                }
            default: 
                return undefined;
        }
    } 

    const onChange = (type: 'actionType' | 'chatbotStep' | 'textMessage', value: any) => {
        const redeployStep = currentActiveStaticWorkflow?.chatbot_version_info?.find((version) => version?.chatbot_version_status_name?.toLowerCase() == currentActiveStaticWorkflow?.currentViewVersion?.toLowerCase())?.chatbot_step_data?.find((step) => ["redeploy", "redeploy chatbot"]?.includes(step.chatbot_step_type?.chatbot_step_type_name?.toLowerCase()));
        if(flagStepLevel){
            let targetChatbotStep = defaultTargetChatbotStep;
            if(value?.key == "ReDeploy"){
                targetChatbotStep = {
                    target_chatbot_step_id: redeployStep?.chatbot_step_id || "", 
                    target_chatbot_step_name: redeployStep?.chatbot_step_name || "", 
                    target_chatbot_step_type: {
                        target_chatbot_step_type_id: redeployStep?.chatbot_step_type?.chatbot_step_type_id || "", 
                        target_chatbot_step_type_name: redeployStep?.chatbot_step_type?.chatbot_step_type_name || "",
                    },
                }
            }

            setNodes((prev: any) => {
                return prev?.map((node: any) => {
                    if(node?.id == stepId){
                        return {
                            ...node, 
                            chatbot_step_exception: node?.chatbot_step_exception ? 
                            {
                                ...node?.chatbot_step_exception,  
                                ...(type == "actionType" && {
                                    action_type: value?.key ?? "", 
                                    flag_redeploy: value?.key == "ReDeploy",
                                    flag_redirect: value?.key == "ReDirect", 
                                    flag_do_nothing: value?.key == "Do Nothing",
                                    target_chatbot_step: targetChatbotStep,
                                }), 
                                ...(type == "chatbotStep" && {
                                    target_chatbot_step: value ? 
                                    {
                                        target_chatbot_step_id: value?.id, 
                                        target_chatbot_step_name: value?.chatbot_step_name, 
                                        target_chatbot_step_type: {
                                            target_chatbot_step_type_id: value?.chatbot_step_type_id, 
                                            target_chatbot_step_type_name: value?.chatbot_step_type_name,
                                        }
                                    }
                                    : defaultTargetChatbotStep,
                                }), 
                                ...(type == "textMessage" && {
                                    exception_message: value,
                                })
                            } : null,
                        }
                    }
                    return node;
                })
            })
        } else {
            let chatbotStep = defaultChatbotStep;
            if(value?.key == "ReDeploy") {
                chatbotStep = {
                    chatbot_step_id: redeployStep?.chatbot_step_id || "", 
                    chatbot_step_name: redeployStep?.chatbot_step_name || "", 
                    chatbot_step_type: {
                        chatbot_step_type_id: redeployStep?.chatbot_step_type?.chatbot_step_type_id || "", 
                        chatbot_step_type_name: redeployStep?.chatbot_step_type?.chatbot_step_type_name || "", 
                    }
                }
            }  

            setCurrentActiveStaticWorkflow((prev: staticWorkflowChatbotDetails | null) => {
                if(!prev) return null;
                return {
                    ...prev, 
                    chatbot_exception: prev?.chatbot_exception ? 
                    {
                        ...prev.chatbot_exception, 
                        ...(type == "actionType" && {
                            action_type: value?.key ?? "", 
                            flag_redeploy: value?.key == "ReDeploy",
                            flag_redirect: value?.key == "ReDirect", 
                            flag_do_nothing: value?.key == "Do Nothing", 
                            chatbot_step: chatbotStep,
                        }), 
                        ...(type == "chatbotStep" && {
                            chatbot_step: value ? 
                                {
                                    chatbot_step_id: value?.chatbot_step_id, 
                                    chatbot_step_name: value?.chatbot_step_name, 
                                    chatbot_step_type: {
                                        chatbot_step_type_id: value?.chatbot_step_type?.chatbot_step_type_id,
                                        chatbot_step_type_name: value?.chatbot_step_type?.chatbot_step_type_name,
                                    }
                                }
                            : defaultChatbotStep,
                        }), 
                        ...(type == "textMessage" && {
                            pre_transition_text_message: value,
                        })
                    } : null,
                }
            });
        }
    }

    const checkDisableSaveBtn = () => {
        if(flagStepLevel){ 

            if(isCurrentViewVersionPublished(currentActiveStaticWorkflow)) return true;
            
            const exception = nodes?.find((node: any) => node?.id == stepId)?.chatbot_step_exception;
            if(exception){
                if(exception?.action_type?.length > 0){
                    switch(exception?.action_type){
                        case 'ReDeploy': 
                        case 'ReDirect': 
                            if(exception?.target_chatbot_step && exception?.target_chatbot_step?.target_chatbot_step_id?.length > 0){
                                return false;
                            } else return true;
                        case 'Do Nothing': 
                            return false;
                    }
                } else return true;
            } else return true;
        } else {
            const chatbotException = currentActiveStaticWorkflow?.chatbot_exception; 
            if(chatbotException){
                if(chatbotException?.action_type?.length > 0){
                    switch(chatbotException?.action_type){
                        case 'ReDeploy': 
                        case 'ReDirect': 
                            if(chatbotException?.chatbot_step && chatbotException?.chatbot_step?.chatbot_step_id?.length > 0){
                                return false;
                            } else return true;
                        case 'Do Nothing': 
                            return false;
                    }
                } else return true;
            } else return true; 
        }
        return true;
    } 

    const onClickOfSaveBtn = () => {
        if(flagStepLevel){
            const step_type_id = nodes?.find((node: any) => node?.id == stepId)?.chatbot_step_type_id;
            updateException(nodes, stepId, step_type_id, false);

            setNodes((prev: any) => {
                return prev?.map((node: any) => {
                    if(node?.id == stepId){
                        return {
                            ...node, 
                            chatbot_step_exception: node?.chatbot_step_exception ? 
                            {
                                ...node?.chatbot_step_exception, 
                                flag_saved_in_BE: true,
                            } : null,
                        }
                    }
                    return node;
                })
            })

            setFlagExceptionPopup(false);
        } else {
           handlePostDeploymentTrigger(false); 
           setCurrentActiveStaticWorkflow((prev: staticWorkflowChatbotDetails | null) => {
                if(!prev) return null;
                return {
                    ...prev, 
                    chatbot_exception: prev?.chatbot_exception ? {
                        ...prev?.chatbot_exception, 
                        flag_saved_in_BE: true,
                    } : null,
                }
            })
           setFlagExceptionPopup(false);
        }
    } 

    const isCurrentNodeStartNode = () => {
        if(stepId){
           return isStartNode(nodes, edges, stepId);
        } 
        return false;
    }

    const checkDisableChatbotStepOption = (targetChatbotStepId: string) => {
        if(stepId){
            return stepId === targetChatbotStepId;
        }
        return false;
    }
    
    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`}>
                        <Grid item className={globalStyles.textCenter}>
                            <Typography className={style.popupTitleTypography}>{flagStepLevel ? "Error Handling - What should happen if this step fails?" : "Chatbot-Level Error Handling" }</Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} />  

                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={style.popupBodyGridContainer} gap={2}>
                                
                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={style.popupFieldTypography}>Handle Error Action <Required /></Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                className={globalStyles.autocompleteParaphrasing}
                                                options={actionTypeForException(currentActiveStaticWorkflow) || []}
                                                getOptionLabel={(option) => option.userText || ""}
                                                renderInput={(params) => <TextField {...params} placeholder='Select Handle Error Action' />}
                                                value={getValue('actionType') as handleErrorActionType | undefined}
                                                onChange={(e, value) => onChange('actionType', value)} 
                                                disabled={flagStepLevel ? isCurrentViewVersionPublished(currentActiveStaticWorkflow) : false}
                                                getOptionDisabled={(option) => isCurrentNodeStartNode() && option?.key == "ReDeploy"} // Goes in Infinite If Start node has Re Deploy Action.
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid> 

                                {((getValue('actionType') as handleErrorActionType | undefined)?.key?.toLowerCase() == "redirect") && 
                                    <Grid item xs={12}>
                                        <Grid container gap={"12px"}>
                                            <Grid item xs={12}>
                                                <Typography className={style.popupFieldTypography}>Chatbot Step <Required /></Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Autocomplete
                                                    className={globalStyles.autocompleteParaphrasing}
                                                    options={flagStepLevel ? nodes?.filter((node: any) => node?.type != "trigger") : currentActiveStaticWorkflow?.chatbot_version_info?.find((version) => version.chatbot_version_status_name?.toLowerCase() == currentActiveStaticWorkflow?.currentViewVersion?.toLowerCase())?.chatbot_step_data?.filter((step) => !["redeploy", "redeploy chatbot"]?.includes(step.chatbot_step_type?.chatbot_step_type_name?.toLowerCase())) || []}
                                                    getOptionLabel={(option) => option?.chatbot_step_name || ""}
                                                    renderInput={(params) => <TextField {...params} placeholder='Select Chatbot Step to Re-Direct' />}
                                                    value={getValue('chatbotStep')}
                                                    onChange={(e, value) => onChange('chatbotStep', value)}
                                                    getOptionDisabled={(option) => checkDisableChatbotStepOption(option?.id)}
                                                    disabled={flagStepLevel ? isCurrentViewVersionPublished(currentActiveStaticWorkflow) : false}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                } 

                                {isWhatsapp && 
                                    <Grid item xs={12}>
                                        <Grid container gap={"12px"}>
                                            <Grid item xs={12}>
                                                <Typography className={style.popupFieldTypography}>Text Message</Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    value={getValue('textMessage') as string | undefined}
                                                    onChange={(e) => onChange('textMessage', e.target.value)}
                                                    className={`${contactStyle.campaignContactPopupTextField} ${globalStyles.fullwidth}`}
                                                    placeholder={`Optional: Enter a custom error message to show the user.`} 
                                                    disabled={flagStepLevel ? isCurrentViewVersionPublished(currentActiveStaticWorkflow) : false}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid> 
                                }

                                <Grid item xs={12} sx={{marginTop: "30px"}}>
                                    <Grid container justifyContent={"center"} gap={"12px"}>
                                        <Grid item>
                                            <GlobalButton
                                                className='borderedButtonStyle'
                                                buttonText='Discard Changes' 
                                                sx={{width: "160px !important"}}
                                                onClick={() => onClickOfCancel()} 
                                                disabled={flagStepLevel ? isCurrentViewVersionPublished(currentActiveStaticWorkflow) : false}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <GlobalButton
                                                className='primaryButtonStyle'
                                                buttonText='Apply' 
                                                sx={{width: "140px !important"}} 
                                                disabled={checkDisableSaveBtn()} 
                                                onClick={() => onClickOfSaveBtn()}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ExceptionPopup
